import React from 'react';
import styled from 'styled-components';
import { translate } from 'react-i18next';

import { Numeric } from 'common/components/Number';

import HistoryEntry from '../../domain/HistoryEntry';

const WeekRow = styled.tr`
  ${({ theme }) => `
    font-size: ${theme.fonts.style.midSmall.fontSize}px;
    text-align: center;
  `}
`;

const NumericWrapper = styled(Numeric)`
  flex: 1;
  text-align: center;
  font-size: 20px;
  margin-top: 3px;
`;

const ReachWrapper = styled(NumericWrapper)`
  color: ${({ theme }) => (theme.colors.reach)};
`;

const ListeningTimeWrapper = styled(NumericWrapper)`
  color: ${({ theme }) => (theme.colors.listeningTime)};
`;

type Props = {
  week: HistoryEntry;

  t: any;
}

export function HistoryPrintingListingWeek({ t, week }: Props) {
  const history = week.withHourlyListeningTime();
  const weekFormatted = t('weekDateRange', { from: history.from, to: history.to });
  return (
    <WeekRow key={`${weekFormatted}`}>
      <td>{weekFormatted}</td>
      <td id={`${weekFormatted}reach`}>
        <ReachWrapper value={history.reach} roundAt={0} />
      </td>
      <td id={`${weekFormatted}listeningTime`}>
        <ListeningTimeWrapper
          value={history.listeningTime}
          roundAt={0}
          suffix={t('time.hours').toLowerCase()}
        />
      </td>
    </WeekRow>
  );
}

export default translate('history')(HistoryPrintingListingWeek);



// WEBPACK FOOTER //
// ./src/statsradio/modules/history/printing/components/HistoryPrintingListingWeek.js